import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { SIZES, COLORS } from '@scope/scope-one-ui/theme';
import { Box, Label, Typography } from '@scope/scope-one-ui/core';
import { AttentionBuzzProps } from './AttentionBuzz.d';

export const AttentionBuzz: FC<AttentionBuzzProps> = ({
  loading,
  value = 0,
  label,
  notApplicable,
}) => {
  if (loading) {
    return <Skeleton width={SIZES.spacing(25)} height={SIZES.spacing(2)} />;
  }

  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h3" color={COLORS.typography.label}>
        Attention Buzz:&nbsp;
      </Typography>
      <Label type="color">
        <Typography variant="body1">
          {notApplicable ? 'n/a' : `${Math.round(value * 100)}% (${label})`}
        </Typography>
      </Label>
    </Box>
  );
};
